import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import {isMobileDevice} from '@/components/all' // 导入检测函数


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/AboutView.vue')
    }, {
        path: '/interpreter',
        name: 'interpreter',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/interpreter.vue')
    } ,{
        path: '/termQry',
        name: 'termQry',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/term.vue')
    } ,{
        path: '/fileQry',
        name: 'fileQry',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/fileQry.vue')
    }, {
        path: '/findNeedListUI',
        name: 'findNeedListUI',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/findNeedListUI.vue')
    }, {
        path: '/interpreterDetail/:id',
        name: 'interpreterDetail',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/interpreterDetail.vue')
    }, {
        path: '/domestic_offices_usa',
        name: 'domestic_offices_usa',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/partners/domestic_offices_usa.vue')
    }, {
        path: '/toInstructions',
        name: 'toInstructions',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/toInstructions.vue')
    }, {
        path: '/toVideo',
        name: 'toVideo',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/soft/toVideo.vue')
    }, {
        path: '/toSoftMenu',
        name: 'toSoftMenu',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/soft/toSoftMenu.vue')
    }, {
        path: '/toSoftwareDown',
        name: 'toSoftwareDown',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/soft/toSoftwareDown.vue')
    }, {
        path: '/toTeam',
        name: 'toTeam',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toTeam.vue')
    }, {
        path: '/toOA',
        name: 'toOA',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toOA.vue')
    }, {
        path: '/toSecurity',
        name: 'toSecurity',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toSecurity.vue')
    }, {
        path: '/toQC',
        name: 'toQC',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toQC.vue')
    }, {
        path: '/toCustomerInstructions',
        name: 'toCustomerInstructions',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toCustomerInstructions.vue')
    }, {
        path: '/toInterpreterTips',
        name: 'toInterpreterTips',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toInterpreterTips.vue')
    }, {
        path: '/toTranslationProcess',
        name: 'toTranslationProcess',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toTranslationProcess.vue')
    }, {
        path: '/my_proj/toProj',
        name: 'toProj',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/my_proj/toProj.vue')
    }, {
        path: '/toEchart',
        name: 'toEchart',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toEchart.vue')
    }, {
        path: '/toRuleDescription',
        name: 'toRuleDescription',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/myGy/toRuleDescription.vue')
    }, {
        path: '/needsDetail',
        name: 'needsDetail',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/needsDetail.vue')
    }, {
        path: '/transStatus/:id',
        name: 'transStatus',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/transStatus.vue')
    }, {
        path: '/login',
        name: 'login',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/login/login.vue')
    }, {
        path: '/register',
        name: 'register',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/login/register.vue')
    }, {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/login/forgetPassword.vue')
    }, {
        path: '/registerCustomer',
        name: 'registerCustomer',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/login/registerCustomer.vue')
    }, {
        path: '/registerInter',
        name: 'registerInter',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/login/registerInter.vue')
    }, {
        path: '/placeOrder',
        name: 'placeOrder',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/order/placeOrder.vue')
    },{
        path: '/custOATemp',
        name: 'custOATemp',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/order/custOATemp.vue')
    }, {
        path: '/transMain',
        name: 'transMain',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/trans/transMain.vue')
    }, {
        path: '/domestic_offices',
        name: 'domestic_offices',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/partners/domestic_offices.vue')
    }, {
        path: '/offices_detail',
        name: 'offices_detail',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/partners/offices_detail.vue')
    }, {
        path: '/userCenter',
        name: 'userCenter',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/userCenter'),
        children: [{
            path: '/detailIncome',
            name: 'detailIncome',
            component: () =>
                import ('../views/userCenter/centerPage/detailIncome.vue')
        }, {
            path: '/myOrder',
            name: 'myOrder',
            component: () =>
                import ('../views/userCenter/centerPage/myOrder.vue')
        }, {
            path: '/orderDetail',
            name: 'orderDetail',
            component: () =>
                import ('../views/userCenter/centerPage/orderDetail.vue')
        }]
    }, {
        path: '/trans/:caseNum',
        name: 'trans',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/newPage/trans.vue')
    }, {
        path: '/proo/:caseNum',
        name: 'proo',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/newPage/proo.vue')
    }, {
        path: '/pm/:caseNum',
        name: 'pm',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/newPage/pm.vue')
    }, {
        path: '/audit/:caseNum',
        name: 'audit',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/newPage/audit.vue')
    }, {
        path: '/customerCenter',
        name: 'customerCenter',
        component: () =>
            import( /* webpackChunkName: "about" */ '../views/customerCenter/index.vue'),
        children: [{
            path: '/informationDesk',
            name: 'informationDesk',
            component: () =>
                import('../views/customerCenter/informationDesk.vue'),
            meta: {
                title: '信息台',
                keepAlive: false
            }
        }, {
            path: '/myInformation',
            name: 'myInformation',
            component: () =>
                import('../views/customerCenter/myInformation.vue'),
            meta: {
                title: '我的资料',
                keepAlive: true
            }
        }, {
            path: '/myOrderNew',
            name: 'myOrderNew',
            component: () =>
                import('../views/customerCenter/myOrder.vue'),
            meta: {
                title: '我的订单',
                keepAlive: true
            }
        }, {
            path: '/orderDetailNew',
            name: 'orderDetailNew',
            component: () =>
                import('../views/customerCenter/orderDetailNew.vue'),
            meta: {title: '订单详情'}
        }, {
            path: '/evaluation',
            name: 'evaluation',
            component: () =>
                import('../views/customerCenter/evaluation.vue'),
            meta: {title: '订单评价'}
        }, {
            path: '/level',
            name: 'level',
            component: () =>
                import('../views/customerCenter/level.vue'),
            meta: {
                title: '我的等级',
                keepAlive: false
            }
        }, {
            path: '/collection',
            name: 'collection',
            component: () =>
                import('../views/customerCenter/collection.vue'),
            meta: {
                title: '我的收藏',
                keepAlive: false
            }
        }, {
            path: '/exchange',
            name: 'exchange',
            component: () =>
                import('../views/customerCenter/exchange.vue'),
            meta: {
                title: '积分兑换',
                keepAlive: false
            }
        }, {
            path: '/priceInquiry',
            name: 'priceInquiry',
            component: () =>
                import('../views/customerCenter/priceInquiry.vue'),
            meta: {
                title: '价格查询',
                keepAlive: false
            }
        }, {
            path: '/bill',
            name: 'bill',
            component: () =>
                import('../views/customerCenter/bill.vue'),
            meta: {
                title: '我的账单',
                keepAlive: false
            }
        }, {
            path: '/payInfo',
            name: 'payInfo',
            component: () =>
                import('../views/customerCenter/payInfo.vue'),
            meta: {
                title: '我的支付',
                keepAlive: false
            }
        }, {
            path: '/listContract',
            name: 'listContract',
            component: () =>
                import('../views/customerCenter/listContract.vue'),
            meta: {
                title: '合同下载',
                keepAlive: false
            }
        }, {
            path: '/listIntegral',
            name: 'listIntegral',
            component: () =>
                import('../views/customerCenter/listIntegral.vue'),
            meta: {
                title: '积分明细',
                keepAlive: false
            }
        }]
    },
    {
        path: '/custTrack',
        name: 'cust_track',
        component: () =>
            import('../views/back/cust_track.vue'),
        meta: {title: '订单评价'}
    },
    {
        path: '/projCenter',
        name: 'projCenter',
        component: () =>
            import( /* webpackChunkName: "about" */ '../views/projCenter/index.vue'),
        children: [
            {
                path: '/workBench',
                name: 'workBench',
                component: () =>
                    import('../views/projCenter/workBench.vue'),
                meta: {
                    title: '信息台',
                    keepAlive: false
                }
            },
            {
                path: '/prjOrder',
                name: 'prjOrder',
                component: () =>
                    import('../views/projCenter/prjOrder.vue'),
                meta: {
                    title: '我的项目',
                    keepAlive: true
                }
            },
            {
                path: '/prjSheet',
                name: 'prjSheet',
                component: () =>
                    import('../views/projCenter/prjSheet.vue'),
                meta: {
                    title: '我的订单',
                    keepAlive: true
                }
            },{
                path: '/prjNeedDetail',
                name: 'prjNeedDetail',
                component: () =>
                    import('../views/projCenter/prjNeedDetail.vue'),
                meta: {
                    title: '项目详情',
                    keepAlive: false
                }
            },{
                path: '/sheetDetail',
                name: 'sheetDetail',
                component: () =>
                    import('../views/projCenter/sheetDetail.vue'),
                meta: {
                    title: '订单详情',
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: '/holiday',
        name: 'holiday',
        component: () =>
            import('../views/holiday/theHold.vue'),
        meta: {title: '订单评价'}
    },
    {
        path: '/uploadFile',
        name: 'uploadFile',
        component: () =>
            import('../views/uploadFile.vue'),
        meta: {title: '上传文件'}
    },
    {
        path: '/sendProo',
        name: 'sendProo',
        component: () =>
            import('../views/base/sendProo.vue'),
        meta: {title: '校对派稿'}
    },
    {
        path: '/transCenter',
        name: 'transCenter',
        component: () =>
            import( /* webpackChunkName: "about" */ '../views/transCenter/index.vue'),
        children: [
            {
                path: '/transCenter/workBench',
                name: 'workBench',
                component: () =>
                    import('../views/transCenter/workBench.vue'),
                meta: {
                    title: '信息台',
                    keepAlive: false
                }
            },{
                path: '/transCenter/transInfo',
                name: 'transInfo',
                component: () =>
                    import('../views/transCenter/transInfo.vue'),
                meta: {
                    title: '个人信息',
                    keepAlive: false
                }
            }
        ]
    },

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    // 如果是移动设备
    if (isMobileDevice()) {
        if (!to.meta.isMobilePage) {
            window.location.href = 'http://global.aitrans.org.cn/h5?token=' + localStorage.getItem('token');
            return // 注意，使用 window.location.href 时，需要 return 来终止后续导航
        }
    }
    next() // 非移动设备，正常进行路由导航
})
export default router